var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('StepProgress',{staticClass:"progress",attrs:{"active-step":_vm.activeStep,"total-step":_vm.totalStep}}),_c('div',{staticClass:"text-wrapper"},[_c('h4',[_vm._t("step",function(){return [_vm._v(" ÜRÜN BİLGİLERİ ")]})],2),_c('span',[_vm._t("nextStep")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }